// Post message communication with the containing app.
// Currently these are only functional within Canvas.

import { getWindowDerivitaEnvironment } from 'derivita/omaha/ui/derivita_environment';
import { isFullScreen } from '../fullscreen/fullscreen_utils';
import { LMS } from 'derivita/ts/environment/environment_service';
import { inAnIFrame, isEmbedded } from '../view_environment/view_environment';

/**
 * Set the height of the iframe that our iframe is rendered in
 * @param height The height that the iframe should be resized to.
 * Defaults to the height of the current application in order to
 * remove the iframe scroll bar.
 */
export function setHeight(height?: number) {
  height = height ? height : document.body.clientHeight;
  height = height > 500 ? height : 500;

  window.parent.postMessage(
    JSON.stringify({ 'subject': 'lti.frameResize', height }),
    '*'
  );
}

/** Remove LMS navigation  */
export function hideLMSNavigation() {
  window.parent.postMessage(
    JSON.stringify({ 'subject': 'lti.showModuleNavigation', 'show': false }),
    '*'
  );
}

/**
 * Can be called after hideLMSNavigation to re-enable
 * navigation elements
 */
export function showLMSNavigation() {
  window.parent.postMessage(
    JSON.stringify({ 'subject': 'lti.showModuleNavigation', 'show': true }),
    '*'
  );
}

/** Tell the parent iframe to scroll to top */
export function scrollParentToTop() {
  window.parent.postMessage(
    JSON.stringify({ 'subject': 'lti.scrollToTop' }),
    '*'
  );
}

export function setLMSUnloadMessage() {
  window.parent.postMessage(
    JSON.stringify({
      'subject': 'lti.setUnloadMessage',
      'message': 'Are you sure you want to leave?',
    }),
    '*'
  );
}

export function removeLMSUnloadMessage() {
  window.parent.postMessage(
    JSON.stringify({ 'subject': 'lti.removeUnloadMessage' }),
    '*'
  );
}

export function canUsePostMessage(): boolean {
  //Canvas is currently the only LMS we can use postmessage with
  return (
    getWindowDerivitaEnvironment().lms === LMS.CANVAS &&
    !isFullScreen(document) &&
    inAnIFrame()
  );
}

export function showLMSAlert(
  alertType: 'warning' | 'success' | 'error',
  message: string
) {
  window.parent.postMessage(
    {
      'subject': 'lti.showAlert',
      'alertType': alertType,
      'body': message,
      'title': 'Derivita',
    },
    '*'
  );
}

export function announceLMSAlert(message: string) {
  window.parent.postMessage(
    {
      'subject': 'lti.screenReaderAlert',
      'body': message,
    },
    '*'
  );
}

/** Launch the app in a new window or tab */
export function launchInNewWindow(launchUrl: string) {
  window.parent.postMessage(
    JSON.stringify({
      'subject': 'requestFullWindowLaunch',
      'data': {
        'url': launchUrl,
        'placement': 'assignment_selection',
        'launchType': 'new_window',
      },
    }),
    '*'
  );
}

export function updateCanvasSpeedGraderGrade() {
  window.parent.postMessage({ 'subject': 'quizzesNext.submissionUpdate' }, '*');
}

export function initializeResizeObserver(
  customHeightPadding?: () => number
): ResizeObserver | undefined {
  if (ResizeObserver && isEmbedded()) {
    return new ResizeObserver((entries) => {
      const last = entries[entries.length - 1];
      const height = last.contentBoxSize?.[0]?.blockSize;
      const padding = customHeightPadding ?? (() => 0);
      if (height) {
        setHeight(height + padding());
      }
    });
  }
}
